export class FieldConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "unit",
            "baseName": "unit",
            "type": "string",
            "format": ""
        },
        {
            "name": "decimals",
            "baseName": "decimals",
            "type": "number",
            "format": ""
        },
        {
            "name": "min",
            "baseName": "min",
            "type": "number",
            "format": "double"
        },
        {
            "name": "max",
            "baseName": "max",
            "type": "number",
            "format": "double"
        },
        {
            "name": "thresholds",
            "baseName": "thresholds",
            "type": "Threshold",
            "format": ""
        },
        {
            "name": "mappings",
            "baseName": "mappings",
            "type": "Array<ValueMapping>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return FieldConfig.attributeTypeMap;
    }
    constructor() {
    }
}
